<template>
    <div id="citation-list">
      <div>
        <kendo-button>Export to Excel</kendo-button>
        <kendo-button>Export to RIS</kendo-button>
        <a href="#" class="k-button k-button-icontext k-grid-excel" @click="reviewAll()">Review All citations</a>
        <a href="#" class="k-button k-button-icontext k-grid-excel" @click="reviewMarked()"><span class="k-icon k-i-check"></span>Review Marked citations</a>
        <a href="#" class="k-button k-button-icontext k-grid-excel" :disabled="true">Clear Marked citations</a>
      </div>
      <kendo-grid id="publications-list-grid"
        :ref="'citationListGrid'"
        style="citation-list-grid"
        :data-source="publicationDataSource"
        :columns="columns"
        :selectable="selectable"
        :sortable="sortable"
        :pageable="pageable"
        :groupable="groupable"
        :excel="excel"
        :scrollable="scrollable"
        :filterable="filterable"
        :filter="filterGrid"
        :change="change"
        :data-bound="dataBound">
      </kendo-grid>
    </div>
</template>

<script>

import PublicationDataSource from '@/assets/data/Citation.json'
import $ from 'jquery'
import mitt from 'mitt'
const emitter = mitt()

export default {
  name: 'citation-list',
  props: ['selected'],
  data () {
    return {
      gridWidget: '',
      excel: { fileName: 'Kendo UI Grid Export.xlsx', allPages: true },
      pageable: {
        refresh: true,
        pageSizes: true,
        buttonCount: 2,
        pageSize: 5
      },
      columns: [
        {
          title: 'Main Citation Fields',
          headerAttributes: { class: 'grid-header-light' },
          columns: [
            { field: 'PublicationIdentity', title: 'Citation ID', width: '120px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Author', title: 'Author', width: '120px', template: '<div id="truncate">#:Author#</div>', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Year', title: 'Year', width: '80px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Title', title: 'Title', width: '300px', template: '<div id="truncate">#:Title#</div>', headerAttributes: { class: 'grid-header-light' } }
          ]
        },
        {
          title: 'Other Citation Fields',
          headerAttributes: { class: 'grid-header-light' },
          columns: [
            { field: 'CurrentStage', title: 'Current Stage', width: '200px', filterable: { extra: false }, headerAttributes: { class: 'grid-header-light' } },
            { field: 'MovedFrom', title: 'Moved From', width: '200px', filterable: { extra: false }, headerAttributes: { class: 'grid-header-light' } },
            { field: 'Tags', title: 'Tags', width: '200px', template: '<button>Tag1</button><button>Tag2</button>', filterable: { extra: true }, filter: 'boolean', headerAttributes: { class: 'grid-header-light' } },
            { field: 'ReviewStatus', title: 'Review Status', width: '200px', filterable: { extra: false }, headerAttributes: { class: 'grid-header-light' } },
            { field: 'ReviewedBy', title: 'Reviewed By', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'ReviewedDate', title: 'Reviewed Date', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'AddedMaterials', title: 'Added Materials', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'FullText', title: 'Full Text Link', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Abstract', title: 'Abstract', width: '400px', template: '<div id="truncate">#:Abstract#</div>', headerAttributes: { class: 'grid-header-light' } },
            { field: 'TypeOfPublication', title: 'Type Of Publication', width: '200px', template: '<div id="truncate">#:TypeOfPublication#</div>', headerAttributes: { class: 'grid-header-light' } },
            { field: 'TypeOfArticle', title: 'Type Of Article', width: '200px', template: '<div id="truncate">#:TypeOfPublication#</div>', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Volume', title: 'Volume', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Issue', title: 'Issue', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Pages', title: 'Page(s)', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'ConferenceName', title: 'Conference Name', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { title: 'Date(s) of Conference', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { title: 'Report Name', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { title: 'Organizing Body', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { title: 'Date of Report', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'DatabaseName', title: 'Name of Database', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'AccessionNumber', title: 'Accession Number', width: '200px', headerAttributes: { class: 'grid-header-light' } },
            { field: 'DOI', title: 'DOI', width: '200px', template: '<div id="truncate">#:DOI#</div>', headerAttributes: { class: 'grid-header-light' } },
            { field: 'URL', title: 'URL', width: '200px', headerAttributes: { class: 'grid-header-light' } }
          ]
        },
        {
          title: 'Study Fields',
          headerAttributes: { class: 'grid-header-dark' },
          columns: [
            { field: 'StudyIdentity', title: 'Registry #', width: '200px', headerAttributes: { class: 'grid-header-dark' } },
            { field: 'StudyAcronym', title: 'Study ID', width: '200px', headerAttributes: { class: 'grid-header-dark' } },
            { field: 'StudyDescription', title: 'Study Description', width: '200px', headerAttributes: { class: 'grid-header-dark' } }
          ]
        }
      ],
      groupable: true,
      selectable: 'multiple row',
      sortable: true,
      scrollable: true,
      filterable: {
        operators: {
          number: {
            eq: 'Equal to',
            neq: 'Not equal to',
            gt: 'Greater than',
            gte: 'Greater than or equal to',
            lt: 'Less than',
            lte: 'Less than or equal to'
          }
        }
      },
      publicationDataSource: PublicationDataSource,
      isMarked: false
    }
  },
  created: function () {
    $('.k-grid-review').attr('disabled', true)
    $('.k-grid-clear').attr('disabled', true)
    emitter.on('removedCitationFilter', (columnName) => {
      var myFilters = this.gridWidget.dataSource.filter().filters
      myFilters.forEach(function (f) {
        if (f.field === columnName) {
          var index = myFilters.indexOf(f)
          myFilters.splice(index, 1)
        }
      })
      this.gridWidget.dataSource.filter([])
      this.gridWidget.dataSource.filter(myFilters)
    })
    emitter.on('removedStudyFilter', (columnName) => {
      var myFilters = this.gridWidget.dataSource.filter().filters
      myFilters.forEach(function (f) {
        if (f.field === columnName) {
          var index = myFilters.indexOf(f)
          myFilters.splice(index, 1)
        }
      })
      this.gridWidget.dataSource.filter([])
      this.gridWidget.dataSource.filter(myFilters)
    })
    emitter.on('removedOtherPublicationFilter', (columnName) => {
      var myFilters = this.gridWidget.dataSource.filter().filters
      myFilters.forEach(function (f) {
        if (f.field === columnName) {
          var index = myFilters.indexOf(f)
          myFilters.splice(index, 1)
        }
      })
      this.gridWidget.dataSource.filter([])
      this.gridWidget.dataSource.filter(myFilters)
    })
  },
  methods: {
    reviewAll () {
      $('.hdr-navigation-item').css('cursor', 'not-allowed')
      $('.hdr-title-text').css('cursor', 'not-allowed')
      $('.hdr-title').css('cursor', 'not-allowed')
      this.$store.state.selectedAction = 'manage-forms'
      this.$store.state.cardSelector = true
      this.$router.push({ path: '/secure/IndividualReview' })
    },
    reviewMarked: function () {
      $('.hdr-navigation-item').css('cursor', 'not-allowed')
      $('.hdr-title-text').css('cursor', 'not-allowed')
      $('.hdr-title').css('cursor', 'not-allowed')
      this.$store.state.selectedAction = 'manage-forms'
      this.$store.state.cardSelector = true
      this.$router.push({ path: '/secure/IndividualReview' })
    },
    disableReview: function (enable) {
      $('.k-grid-review').attr('disabled', enable)
    },
    disableClear: function (enable) {
      $('.k-grid-clear').attr('disabled', enable)
    },
    clearMarkedPublications: function () {
      // TODO
    },
    getColumnIndexFromField: function (field) {
      var index = -1
      var columns = this.gridWidget.options.columns
      if (columns.length > 0) {
        for (var i = 0; i < columns.length; i++) {
          if (columns[i].field === field) {
            index = i
          }
        }
      }
      if (index === -1) {
        console.log('column ' + field + ' not exists')
      } else {
        return index
      }
    },
    filterGrid: function (e) {
      if (e.field === 'PublicationIdentity' | e.field === 'Author' | e.field === 'Year' | e.field === 'Title' | e.field === 'Abstract' | e.field === 'TypeOfPublication' | e.field === 'Volume' | e.field === 'Issue' | e.field === 'Pages' | e.field === 'ConferenceName' | e.field === 'ConferenceDates' | e.field === 'ReportName' | e.field === 'ReportDates' | e.field === 'OrganizingBody' | e.field === 'AccessionNumber' | e.field === 'DOI') {
        emitter.emit('addedCitationFilter', e.field, e.filter)
      }
      if (e.field === 'StudyIdentity' | e.field === 'StudyAcronym' | e.field === 'StudyDescription') {
        emitter.emit('addedStudyFilter', e.field, e.filter)
      }
      if (e.field === 'CurrentStage' | e.field === 'MovedFrom' | e.field === 'MovedBy' | e.field === 'DateMoved' | e.field === 'AddedMaterials' | e.field === 'FullText') {
        emitter.emit('addedOtherPublicationFilter', e.field, e.filter)
      }
    },
    change: function () {
      var selectedRows = this.$refs.citationListGrid.kendoWidget().select()
      this.$store.state.isStudyMapping = false
      for (var i = 0; i < selectedRows.length; i++) {
        var dataItem = this.$refs.citationListGrid.kendoWidget().dataItem(selectedRows[i])
        console.log(dataItem)
        if (dataItem.CurrentStage === 'Study Mapping') {
          this.$store.state.isStudyMapping = true
        }
      }
      this.disableReview(selectedRows.length === 0)
      this.disableClear(selectedRows.length === 0)
    },
    dataBound: function (e) {
      var selectedDataItems = this.$store.state.selectedDataItems
      if (selectedDataItems.length > 0) {
        var grid = e.sender
        var items = grid.items()
        items.each(function (idx, row) {
          var dataItem = grid.dataItem(row)
          if (selectedDataItems.indexOf(dataItem) !== -1) {
            e.sender.select('tr:eq(' + idx + ')')
          }
        })
      }
    }
  }
}
</script>
